import { ThemeOptions } from "@mui/material/styles";

export const menuOverrides: ThemeOptions["components"] = {
	MuiMenu: {
		styleOverrides: {
			paper: ({ theme }) => ({
				boxShadow: "none",
				backgroundColor: theme.palette.common.white,
				border: "1px solid",
				borderColor: theme.palette.dirtyWhite["400"],
				borderRadius: theme.spacing(2),
			}),

			list: {
				paddingTop: 0,
				paddingBottom: 0,
			},
		},
	},
};
